import React, { Component } from "react";
import CircularProgress from "material-ui/CircularProgress";

const styles = {
    base: {
        position: "fixed",
        top: "0px",
        left: "0px",
        right: "0px",
        bottom: "0px",
        zIndex: 2,
    },
};

class Loading extends Component {
    render() {
        return (
            <div style={{ ...styles.base, ...this.props.style }}>
                <div className="site-loading">
                    <div>
                        <CircularProgress />
                    </div>
                </div>
            </div>
        );
    }
}

export default Loading;
